import config from '../config';
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = config.api.API_URL + '/job_step';

export const jobStepService = {
  getByJobId,
};

function getByJobId(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/job/${id}`, requestOptions, signal).then(handleResponse);
}
